var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.button,on:{"click":function($event){return _vm.setActiveModal('Main')}}},[_vm._v("\n  Find Your Size\n")])}
var staticRenderFns = []

export { render, staticRenderFns }